import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { Document } from '@contentful/rich-text-types';
import {
  fadeInOnEnterAnimation,
  fadeOutOnLeaveAnimation,
} from 'angular-animations';
import { IAccordionItem } from './accordion.interface';
import { Store } from '@ngxs/store';
import { QuoteActions } from '@nibtravel/shared/data-access/quote';

@Component({
  selector: 'nibtravel-accordion',
  templateUrl: 'accordion.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    fadeInOnEnterAnimation(),
    fadeOutOnLeaveAnimation({ duration: 350 }),
  ],
})
export class AccordionComponent {
  @HostBinding('class.open') isOpen = false;

  @Input()
  @HostBinding('attr.data-e2e')
  e2eId: string | undefined;

  @Input() title!: string;
  @Input() content!: string | Document;
  @Input() childrenCustomTemplate = false;
  @Input() children!: IAccordionItem[];

  isRichText(data: string | Document): boolean {
    return !(data instanceof String || typeof data === 'string');
  }

  toggleOpen(title: string): void {
    this.isOpen = !this.isOpen;
    this._store.dispatch(
      new QuoteActions.TogglePlanDetailsAccordion({
        title,
        accordionOpen: this.isOpen,
      })
    );
  }

  constructor(public _store: Store) {}
}
